var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndulatingWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 127,
    viewBox: "0 0 441 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.365 67.5398C195.092 67.5398 192.429 64.8753 192.429 61.5998V35.1998C192.429 31.9242 195.092 29.2598 198.365 29.2598C201.638 29.2598 204.301 31.9242 204.301 35.1998V61.5753C204.301 64.8753 201.638 67.5398 198.365 67.5398Z",
    fill: "#00E36B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.365 55.6357C201.638 55.6357 204.301 58.3002 204.301 61.5757C204.301 64.8513 201.638 67.5157 198.365 67.5157C195.092 67.5157 192.429 64.8513 192.429 61.5757C192.429 58.3002 195.092 55.6357 198.365 55.6357ZM198.365 57.5669C196.142 57.5669 194.335 59.3757 194.335 61.6002C194.335 63.8246 196.142 65.6335 198.365 65.6335C200.588 65.6335 202.395 63.8246 202.395 61.6002C202.395 59.3513 200.588 57.5669 198.365 57.5669Z",
    fill: "#00E36B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.635 75.7536C180.362 75.7536 177.7 73.0892 177.7 69.8136V43.438C177.7 40.1625 180.362 37.498 183.635 37.498C186.909 37.498 189.571 40.1625 189.571 43.438V69.8136C189.571 73.0892 186.909 75.7536 183.635 75.7536Z",
    fill: "#0AF0B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.636 67.8585C186.86 67.8585 189.474 65.1991 189.474 61.9185C189.474 58.6379 186.86 55.9785 183.636 55.9785C180.411 55.9785 177.797 58.6379 177.797 61.9185C177.797 65.1991 180.411 67.8585 183.636 67.8585Z",
    fill: "#0AF0B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9087 62.5958C57.2886 59.3372 54.9569 56.3874 51.7006 56.0072C48.4444 55.627 45.4966 57.9604 45.1167 61.2189C44.7367 64.4775 47.0684 67.4274 50.3247 67.8076C53.581 68.1878 56.5288 65.8544 56.9087 62.5958Z",
    fill: "#0AF0B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.726 67.74C25.936 67.0737 27.9986 63.9294 27.3328 60.7171C26.6669 57.5048 23.5249 55.4408 20.3149 56.1071C17.1048 56.7733 15.0423 59.9176 15.7081 63.1299C16.3739 66.3423 19.5159 68.4063 22.726 67.74Z",
    fill: "#00E368"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6839 62.6654C13.0976 59.411 10.7967 56.4373 7.54469 56.0233C4.29267 55.6093 1.32101 57.9118 0.907299 61.1661C0.493585 64.4204 2.79448 67.3942 6.0465 67.8082C9.29851 68.2222 12.2702 65.9197 12.6839 62.6654Z",
    fill: "#00E36B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2669 55.9531C39.5401 55.9531 42.2027 58.6176 42.2027 61.8931C42.2027 65.1687 39.5401 67.8331 36.2669 67.8331C32.9937 67.8331 30.3311 65.1687 30.3311 61.8931C30.3067 58.6176 32.9692 55.9531 36.2669 55.9531ZM36.2669 57.8842C34.044 57.8842 32.2364 59.6931 32.2364 61.9176C32.2364 64.142 34.044 65.9509 36.2669 65.9509C38.4897 65.9509 40.2973 64.142 40.2973 61.9176C40.2973 59.6931 38.4897 57.8842 36.2669 57.8842Z",
    fill: "#00E36B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.422 68.0534C136.149 68.0534 133.487 65.389 133.487 62.1134V35.7378C133.487 32.4623 136.149 29.7979 139.422 29.7979C142.696 29.7979 145.358 32.4623 145.358 35.7378V62.1134C145.358 65.389 142.696 68.0534 139.422 68.0534Z",
    fill: "#00E36B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.422 40.8464C136.149 40.8464 133.487 38.182 133.487 34.9064V8.50641C133.487 5.23086 136.149 2.56641 139.422 2.56641C142.696 2.56641 145.358 5.23086 145.358 8.50641V34.882C145.358 38.182 142.696 40.8464 139.422 40.8464Z",
    fill: "#0AF0B8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.423 14.2999C142.696 14.2999 145.358 11.6355 145.358 8.35992C145.358 5.08436 142.696 2.41992 139.423 2.41992C136.149 2.41992 133.487 5.08436 133.487 8.35992C133.462 11.6355 136.125 14.2999 139.423 14.2999Z",
    fill: "#00E36B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9282 67.8523C69.2044 67.7401 71.7695 64.9913 71.6573 61.7127C71.5452 58.4341 68.7983 55.8672 65.5221 55.9794C62.2458 56.0916 59.6808 58.8404 59.7929 62.1191C59.905 65.3977 62.6519 67.9645 65.9282 67.8523Z",
    fill: "#00E36B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7259 81.6442C62.4527 81.6442 59.7902 78.9798 59.7902 75.7042V49.3287C59.7902 46.0531 62.4527 43.3887 65.7259 43.3887C68.9992 43.3887 71.6617 46.0531 71.6617 49.3287V75.7042C71.6862 78.9798 69.0236 81.6442 65.7259 81.6442Z",
    fill: "#00E36B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.48 67.6374C77.2067 67.6374 74.5442 64.9729 74.5442 61.6974V35.3218C74.5442 32.0463 77.2067 29.3818 80.48 29.3818C83.7532 29.3818 86.4158 32.0463 86.4158 35.3218V61.6974C86.4158 64.9729 83.7532 67.6374 80.48 67.6374Z",
    fill: "#00E36B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.48 95.2595C77.2067 95.2595 74.5442 92.595 74.5442 89.3195V62.9439C74.5442 59.6683 77.2067 57.0039 80.48 57.0039C83.7532 57.0039 86.4158 59.6683 86.4158 62.9439V89.3195C86.4158 92.595 83.7532 95.2595 80.48 95.2595Z",
    fill: "#00E36B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2095 121.954C91.9362 121.954 89.2737 119.289 89.2737 116.014V89.6382C89.2737 86.3627 91.9362 83.6982 95.2095 83.6982C98.4827 83.6982 101.145 86.3627 101.145 89.6382V116.014C101.145 119.289 98.4827 121.954 95.2095 121.954Z",
    fill: "#0AF0B8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2095 94.2336C91.9362 94.2336 89.2737 91.5692 89.2737 88.2936V58.3736C89.2737 55.098 91.9362 52.4336 95.2095 52.4336C98.4827 52.4336 101.145 55.098 101.145 58.3736V88.2692C101.145 91.5692 98.4827 94.2336 95.2095 94.2336Z",
    fill: "#0AF0B8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2095 95.2595C98.4827 95.2595 101.145 92.6684 101.145 89.4662C101.145 86.264 98.4827 83.6729 95.2095 83.6729C91.9363 83.6729 89.2737 86.264 89.2737 89.4662C89.2493 92.6684 91.9118 95.2595 95.2095 95.2595Z",
    fill: "#00E368"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2097 38.28C91.9365 38.28 89.2739 35.6156 89.2739 32.34V5.94C89.2739 2.66445 91.9365 0 95.2097 0C98.4829 0 101.145 2.66445 101.145 5.94V32.3156C101.145 35.6156 98.4829 38.28 95.2097 38.28Z",
    fill: "#00E36B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2095 65.487C91.9362 65.487 89.2737 62.8226 89.2737 59.547V33.147C89.2737 29.8715 91.9362 27.207 95.2095 27.207C98.4827 27.207 101.145 29.8715 101.145 33.147V59.5226C101.145 62.8226 98.4827 65.487 95.2095 65.487Z",
    fill: "#00E36B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.939 56.5645C106.666 56.5645 104.003 59.2289 104.003 62.5045V88.9044C104.003 92.18 106.666 94.8444 109.939 94.8444C113.212 94.8444 115.875 92.18 115.875 88.9044V62.5289C115.899 59.2289 113.237 56.5645 109.939 56.5645Z",
    fill: "#00E36B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.939 28.9668C106.666 28.9668 104.003 31.6312 104.003 34.9068V61.2824C104.003 64.5579 106.666 67.2224 109.939 67.2224C113.212 67.2224 115.875 64.5579 115.875 61.2824V34.9068C115.899 31.6312 113.237 28.9668 109.939 28.9668Z",
    fill: "#00E36B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.152 67.5398C150.879 67.5398 148.216 64.8753 148.216 61.5998V35.1998C148.216 31.9242 150.879 29.2598 154.152 29.2598C157.425 29.2598 160.088 31.9242 160.088 35.1998V61.5753C160.088 64.8753 157.425 67.5398 154.152 67.5398Z",
    fill: "#00E36B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.152 95.1374C150.879 95.1374 148.216 92.4729 148.216 89.1974V62.8218C148.216 59.5463 150.879 56.8818 154.152 56.8818C157.425 56.8818 160.088 59.5463 160.088 62.8218V89.1974C160.088 92.4729 157.425 95.1374 154.152 95.1374Z",
    fill: "#00E36B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.882 56.4668C165.608 56.4668 162.946 59.1312 162.946 62.4068V88.7824C162.946 92.0579 165.608 94.7224 168.882 94.7224C172.155 94.7224 174.817 92.0579 174.817 88.7824V62.4312C174.842 59.1312 172.179 56.4668 168.882 56.4668Z",
    fill: "#00E36B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.882 38.5C165.608 38.5 162.946 41.1644 162.946 44.44V70.8156C162.946 74.0911 165.608 76.7556 168.882 76.7556C172.155 76.7556 174.817 74.0911 174.817 70.8156V44.4644C174.842 41.1645 172.179 38.5 168.882 38.5Z",
    fill: "#00E36B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.095 94.7468C209.821 94.7468 207.159 92.0823 207.159 88.8068V62.4312C207.159 59.1557 209.821 56.4912 213.095 56.4912C216.368 56.4912 219.03 59.1557 219.03 62.4312V88.8068C219.03 92.0823 216.368 94.7468 213.095 94.7468Z",
    fill: "#0AF0B8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.095 40.8464C209.821 40.8464 207.159 38.182 207.159 34.9064V8.50641C207.159 5.23086 209.821 2.56641 213.095 2.56641C216.368 2.56641 219.03 5.23086 219.03 8.50641V34.882C219.055 38.182 216.392 40.8464 213.095 40.8464Z",
    fill: "#00E36B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.095 67.0261C209.821 67.0261 207.159 64.3617 207.159 61.0861V34.6861C207.159 31.4105 209.821 28.7461 213.095 28.7461C216.368 28.7461 219.03 31.4105 219.03 34.6861V61.0616C219.03 64.3616 216.368 67.0261 213.095 67.0261Z",
    fill: "#00E36B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.095 121.953C209.821 121.953 207.159 119.288 207.159 116.013V89.6373C207.159 86.3617 209.821 83.6973 213.095 83.6973C216.368 83.6973 219.03 86.3617 219.03 89.6373V116.013C219.03 119.288 216.368 121.953 213.095 121.953Z",
    fill: "#00E36B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.849 94.7468C224.575 94.7468 221.913 92.0823 221.913 88.8068V62.4312C221.913 59.1557 224.575 56.4912 227.849 56.4912C231.122 56.4912 233.784 59.1557 233.784 62.4312V88.8068C233.784 92.0823 231.122 94.7468 227.849 94.7468Z",
    fill: "#0AF0B8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.849 51.6267C224.575 51.6267 221.913 48.9622 221.913 45.6867V19.2867C221.913 16.0111 224.575 13.3467 227.849 13.3467C231.122 13.3467 233.784 16.0111 233.784 19.2867V45.6622C233.784 48.9622 231.122 51.6267 227.849 51.6267Z",
    fill: "#0AF0B8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.849 68.5671C224.575 68.5671 221.913 65.9026 221.913 62.6271V36.2515C221.913 32.976 224.575 30.3115 227.849 30.3115C231.122 30.3115 233.784 32.976 233.784 36.2515V62.6271C233.784 65.9026 231.122 68.5671 227.849 68.5671Z",
    fill: "#0AF0B8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.849 68.4689C231.122 68.4689 233.784 65.8044 233.784 62.5289C233.784 59.2533 231.122 56.5889 227.849 56.5889C224.575 56.5889 221.913 59.2533 221.913 62.5289C221.888 65.8044 224.551 68.4689 227.849 68.4689Z",
    fill: "#00E36B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.849 111.686C224.575 111.686 221.913 109.022 221.913 105.746V79.3707C221.913 76.0951 224.575 73.4307 227.849 73.4307C231.122 73.4307 233.784 76.0951 233.784 79.3707V105.746C233.784 109.022 231.122 111.686 227.849 111.686Z",
    fill: "#00E36B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.669 80.8864C121.395 80.8864 118.733 78.222 118.733 74.9464V48.5709C118.733 45.2953 121.395 42.6309 124.669 42.6309C127.942 42.6309 130.604 45.2953 130.604 48.5709V74.9464C130.629 78.222 127.966 80.8864 124.669 80.8864Z",
    fill: "#0AF0B8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.627 59.375C245.9 59.375 248.563 62.0394 248.563 65.315V91.6906C248.563 94.9661 245.9 97.6306 242.627 97.6306C239.354 97.6306 236.691 94.9661 236.691 91.6906V65.315C236.667 62.0394 239.329 59.375 242.627 59.375Z",
    fill: "#00E36B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.627 71.2794C239.354 71.2794 236.691 68.615 236.691 65.3394C236.691 62.0639 239.354 59.3994 242.627 59.3994C245.9 59.3994 248.563 62.0639 248.563 65.3394C248.563 68.615 245.9 71.2794 242.627 71.2794ZM242.627 69.3483C244.85 69.3483 246.657 67.5394 246.657 65.315C246.657 63.0905 244.85 61.2816 242.627 61.2816C240.404 61.2816 238.596 63.0905 238.596 65.315C238.596 67.5394 240.404 69.3483 242.627 69.3483Z",
    fill: "#00E36B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.356 51.1621C260.63 51.1621 263.292 53.8266 263.292 57.1021V83.4777C263.292 86.7532 260.63 89.4177 257.356 89.4177C254.083 89.4177 251.421 86.7532 251.421 83.4777V57.1021C251.396 53.8266 254.059 51.1621 257.356 51.1621Z",
    fill: "#0AF0B8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M257.356 70.9376C260.581 70.9376 263.194 68.2782 263.194 64.9976C263.194 61.717 260.581 59.0576 257.356 59.0576C254.132 59.0576 251.518 61.717 251.518 64.9976C251.518 68.2782 254.132 70.9376 257.356 70.9376Z",
    fill: "#0AF0B8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M395.888 65.6681C396.268 62.4095 393.937 59.4597 390.68 59.0795C387.424 58.6992 384.476 61.0326 384.096 64.2912C383.716 67.5498 386.048 70.4996 389.304 70.8799C392.561 71.2601 395.508 68.9267 395.888 65.6681Z",
    fill: "#0AF0B8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M420.679 70.8073C423.889 70.141 425.951 66.9968 425.285 63.7845C424.619 60.5721 421.477 58.5082 418.267 59.1744C415.057 59.8407 412.995 62.985 413.661 66.1973C414.326 69.4096 417.468 71.4736 420.679 70.8073Z",
    fill: "#00E368"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M440.093 65.7728C440.506 62.5185 438.206 59.5447 434.953 59.1307C431.701 58.7167 428.73 61.0192 428.316 64.2736C427.902 67.5279 430.203 70.5016 433.455 70.9156C436.707 71.3297 439.679 69.0271 440.093 65.7728Z",
    fill: "#00E36B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.725 70.962C401.452 70.962 398.789 68.2976 398.789 65.022C398.789 61.7465 401.452 59.082 404.725 59.082C407.998 59.082 410.661 61.7465 410.661 65.022C410.661 68.2976 407.998 70.962 404.725 70.962ZM404.725 69.0309C406.948 69.0309 408.755 67.222 408.755 64.9976C408.755 62.7731 406.948 60.9643 404.725 60.9643C402.502 60.9643 400.695 62.7731 400.695 64.9976C400.695 67.222 402.502 69.0309 404.725 69.0309Z",
    fill: "#00E36B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.569 58.8623C304.843 58.8623 307.505 61.5268 307.505 64.8023V91.1779C307.505 94.4534 304.843 97.1179 301.569 97.1179C298.296 97.1179 295.634 94.4534 295.634 91.1779V64.8023C295.609 61.5268 298.272 58.8623 301.569 58.8623Z",
    fill: "#00E36B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.569 86.0693C304.843 86.0693 307.505 88.7338 307.505 92.0093V118.385C307.505 121.66 304.843 124.325 301.569 124.325C298.296 124.325 295.634 121.66 295.634 118.385V92.0338C295.609 88.7338 298.272 86.0693 301.569 86.0693Z",
    fill: "#0AF0B8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.569 112.615C298.296 112.615 295.634 115.28 295.634 118.555C295.634 121.831 298.296 124.495 301.569 124.495C304.843 124.495 307.505 121.831 307.505 118.555C307.505 115.28 304.843 112.615 301.569 112.615Z",
    fill: "#00E36B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M375.439 70.9324C378.715 70.8201 381.28 68.0713 381.168 64.7927C381.056 61.5141 378.309 58.9473 375.033 59.0595C371.756 59.1717 369.191 61.9205 369.303 65.1991C369.416 68.4777 372.162 71.0446 375.439 70.9324Z",
    fill: "#00E36B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.242 45.2461C378.515 45.2461 381.177 47.9105 381.177 51.1861V77.5616C381.177 80.8372 378.515 83.5017 375.242 83.5017C371.968 83.5017 369.306 80.8372 369.306 77.5616V51.2105C369.306 47.9105 371.968 45.2461 375.242 45.2461Z",
    fill: "#00E36B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.512 59.2529C363.785 59.2529 366.448 61.9174 366.448 65.1929V91.5929C366.448 94.8685 363.785 97.5329 360.512 97.5329C357.239 97.5329 354.576 94.8685 354.576 91.5929V65.2174C354.576 61.9174 357.239 59.2529 360.512 59.2529Z",
    fill: "#00E36B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.512 31.6553C363.785 31.6553 366.448 34.3197 366.448 37.5953V63.9708C366.448 67.2464 363.785 69.9108 360.512 69.9108C357.239 69.9108 354.576 67.2464 354.576 63.9708V37.5953C354.576 34.3197 357.239 31.6553 360.512 31.6553Z",
    fill: "#00E36B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.782 4.96191C349.056 4.96191 351.718 7.62636 351.718 10.9019V37.2775C351.718 40.553 349.056 43.2175 345.782 43.2175C342.509 43.2175 339.847 40.553 339.847 37.2775V10.9019C339.822 7.62636 342.485 4.96191 345.782 4.96191Z",
    fill: "#0AF0B8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.782 32.6816C349.056 32.6816 351.718 35.3461 351.718 38.6216V68.5172C351.718 71.7927 349.056 74.4572 345.782 74.4572C342.509 74.4572 339.847 71.7927 339.847 68.5172V38.6461C339.822 35.3461 342.485 32.6816 345.782 32.6816Z",
    fill: "#0AF0B8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.782 31.6553C342.509 31.6553 339.847 34.2464 339.847 37.4486C339.847 40.6508 342.509 43.2419 345.782 43.2419C349.056 43.2419 351.718 40.6508 351.718 37.4486C351.718 34.2464 349.056 31.6553 345.782 31.6553Z",
    fill: "#00E368"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.782 88.6348C349.056 88.6348 351.718 91.2992 351.718 94.5748V120.95C351.718 124.226 349.056 126.89 345.782 126.89C342.509 126.89 339.847 124.226 339.847 120.95V94.5992C339.822 91.2992 342.485 88.6348 345.782 88.6348Z",
    fill: "#00E36B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.782 61.4287C349.056 61.4287 351.718 64.0932 351.718 67.3687V93.7443C351.718 97.0198 349.056 99.6843 345.782 99.6843C342.509 99.6843 339.847 97.0198 339.847 93.7443V67.3932C339.822 64.0932 342.485 61.4287 345.782 61.4287Z",
    fill: "#00E36B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.028 70.3259C334.302 70.3259 336.964 67.6614 336.964 64.3859V38.0103C336.964 34.7348 334.302 32.0703 331.028 32.0703C327.755 32.0703 325.093 34.7348 325.093 38.0103V64.3859C325.093 67.6614 327.755 70.3259 331.028 70.3259Z",
    fill: "#00E36B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.028 97.9479C334.302 97.9479 336.964 95.2835 336.964 92.0079V65.6324C336.964 62.3568 334.302 59.6924 331.028 59.6924C327.755 59.6924 325.093 62.3568 325.093 65.6324V92.0079C325.093 95.2835 327.755 97.9479 331.028 97.9479Z",
    fill: "#00E36B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.84 59.375C290.113 59.375 292.776 62.0394 292.776 65.315V91.6906C292.776 94.9661 290.113 97.6306 286.84 97.6306C283.567 97.6306 280.904 94.9661 280.904 91.6906V65.315C280.88 62.0394 283.542 59.375 286.84 59.375Z",
    fill: "#00E36B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.84 31.7773C290.113 31.7773 292.776 34.4418 292.776 37.7173V64.0929C292.776 67.3685 290.113 70.0329 286.84 70.0329C283.567 70.0329 280.904 67.3685 280.904 64.0929V37.7173C280.88 34.4418 283.542 31.7773 286.84 31.7773Z",
    fill: "#00E36B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.086 70.4489C275.359 70.4489 278.022 67.7845 278.022 64.5089V38.1089C278.022 34.8334 275.359 32.1689 272.086 32.1689C268.813 32.1689 266.15 34.8334 266.15 38.1089V64.4845C266.15 67.7845 268.813 70.4489 272.086 70.4489Z",
    fill: "#00E36B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.086 88.4157C275.359 88.4157 278.022 85.7513 278.022 82.4757V56.0757C278.022 52.8002 275.359 50.1357 272.086 50.1357C268.813 50.1357 266.15 52.8002 266.15 56.0757V82.4513C266.15 85.7513 268.813 88.4157 272.086 88.4157Z",
    fill: "#00E36B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.299 46.0283C319.572 46.0283 322.235 48.6928 322.235 51.9683V78.3439C322.235 81.6194 319.572 84.2839 316.299 84.2839C313.026 84.2839 310.363 81.6194 310.363 78.3439V51.9683C310.363 48.6928 313.026 46.0283 316.299 46.0283Z",
    fill: "#0AF0B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndulatingWave);
export default __webpack_public_path__ + "static/media/undulating-wave.c5428a2ec191ddb9b86b04788a793bf6.svg";
export { ForwardRef as ReactComponent };